module.exports = "<div class=\"panel-wrap\">\n\t<header class=\"panel-header\" ng-transclude=\"header\">\n\t\t\n\t</header>\n\t<!-- .panel-header END -->\n\n\t<div class=\"panel-content\" ng-transclude=\"content\">\n\t\t\n\t</div>\n\t<!-- .panel-content END -->\n</div>\n<!-- .panel-wrap END -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpPanelWithHeading/adpPanelWithHeading.html
// module id = 519
// module chunks = 0